var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "放弃跟进 ",
            "mask-closable": false,
            closable: false
          },
          model: {
            value: _vm.giveUpFollowShow,
            callback: function($$v) {
              _vm.giveUpFollowShow = $$v
            },
            expression: "giveUpFollowShow"
          }
        },
        [
          _c("Alert", { attrs: { type: "warning" } }, [
            _vm._v("该客户将从您的客户和回访列表消失，请确认是否放弃")
          ]),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "formValidate",
              attrs: { model: _vm.formValidate, "label-width": 80 }
            },
            [
              _c(
                "FormItem",
                { attrs: { "label-width": 0, prop: "type" } },
                [
                  _c(
                    "RadioGroup",
                    {
                      on: { "on-change": _vm.changeRadio },
                      model: {
                        value: _vm.formValidate.type,
                        callback: function($$v) {
                          _vm.$set(_vm.formValidate, "type", $$v)
                        },
                        expression: "formValidate.type"
                      }
                    },
                    [
                      _c("Radio", { attrs: { label: "1" } }, [
                        _vm._v("签单几率低")
                      ]),
                      _vm._v(" "),
                      _c("Radio", { attrs: { label: "2" } }, [
                        _vm._v("数据有误")
                      ]),
                      _vm._v(" "),
                      _c("Radio", { attrs: { label: "3" } }, [_vm._v("战败")]),
                      _vm._v(" "),
                      _c("Radio", { attrs: { label: "4" } }, [_vm._v("其他")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.descShow_3
                ? _c(
                    "FormItem",
                    { attrs: { "label-width": 0, prop: "descShow_3" } },
                    [
                      _c("Input", {
                        attrs: {
                          type: "textarea",
                          maxlength: 200,
                          autosize: { minRows: 2, maxRows: 5 },
                          placeholder: "必填：请在200字内填写战败原因"
                        },
                        model: {
                          value: _vm.formValidate.descShow_3,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate, "descShow_3", $$v)
                          },
                          expression: "formValidate.descShow_3"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.descShow_4
                ? _c(
                    "FormItem",
                    { attrs: { "label-width": 0, prop: "descShow_4" } },
                    [
                      _c("Input", {
                        attrs: {
                          type: "textarea",
                          maxlength: 200,
                          autosize: { minRows: 2, maxRows: 5 },
                          placeholder: "必填：请在200字内填写放弃原因"
                        },
                        model: {
                          value: _vm.formValidate.descShow_4,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate, "descShow_4", $$v)
                          },
                          expression: "formValidate.descShow_4"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: {
                    type: "text",
                    size: "large",
                    loading: _vm.followLoading
                  },
                  on: { click: _vm.handleCancel }
                },
                [
                  !_vm.followLoading
                    ? _c("span", [_vm._v("取消")])
                    : _c("span", [
                        _vm._v(
                          "\n                    放弃跟进中...\n                "
                        )
                      ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: {
                    type: "primary",
                    size: "large",
                    loading: _vm.followLoading
                  },
                  on: { click: _vm.handleSubmit }
                },
                [
                  !_vm.followLoading
                    ? _c("span", [_vm._v("确定")])
                    : _c("span", [
                        _vm._v(
                          "\n                    放弃跟进中...\n                "
                        )
                      ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a72cea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a72cea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CRM_giveUpFollow.vue
// module id = null
// module chunks = 